class LocalStorageService {
  getItem = (key: string) => {
    return localStorage.getItem(key);
  };

  setItem = (key: string, value: string) => {
    if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  };

  removeItem = (key: string) => {
    localStorage.removeItem(key);
  };

  clear = async () => {
    localStorage.clear();
  };
}

export default new LocalStorageService();
